import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(marketing)/(tools)/free-business-valuation/_assets/og-valuation-tool.png");
;
import(/* webpackMode: "eager", webpackExports: ["LocalMarketContent"] */ "/vercel/path0/apps/web/app/(marketing)/(tools)/free-business-valuation/_components/local-market-content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(marketing)/(tools)/free-business-valuation/_components/valuation-tool.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/common/image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.1_@opentelemetry+api@1.9.1_@playwright+test@1.62.1_@types+node@24.0.8_babel-plugin-_xhv6slofrqmj5g6qy5kbnyd6tu/node_modules/next/dist/client/app-dir/link.js");
